import React, { Component } from "react";
import {
  DKLabel,
  DKButton,
  DKIcons,
  showAlert,
  DKIcon,
  DKListPicker,
  INPUT_TYPE,
  showLoader,
  removeLoader,
  DKCheckMark,
  showToast,
  TOAST_TYPE,
} from "deskera-ui-library";
import FormFieldSelectOptions from "./FormFieldSelectOptions";
import ContactService from "../../../services/contact";
import { isViewportLarge } from "../../../utility/ViewportSizeUtils";
import Utility from "../../../utility/Utility";

/*
PROPS
- header
- subHeader
- data
- onCancel
- onSave (data)
- onCustomFieldSave (data)
*/

class FormFieldsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptionsField: undefined,
      fieldsData: props.data,
      customFieldTitle: undefined,
      customFieldType: undefined,
      customFieldRequired: false,
      addCustomFieldClicked: false,
      showFieldTypeListPicker: false,
      showSaveAction: false,
      needSelectOptionsPopup: false,
      selectOptionsData: [],
      customFieldTitleError: false,
      customFieldTypeError: false,
      isDesktop: isViewportLarge(),
      selectedArrangedFields : props.selectedFields
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.windowSizeUpdated);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.windowSizeUpdated);
  }

  windowSizeUpdated = () => {
    this.setState({
      isDesktop: isViewportLarge(),
    });
  };

  render() {
    return (
      <div className="transparent-background">
        <div className="popup-window justify-content-center align-items-center p-xl d-block">
          <div className="row justify-content-center">
            <DKIcon
              src={DKIcons.data_type.ic_multi_select}
              className="ic-s mr-r"
            />
            <DKLabel text={this.props.header} className="fw-m fs-xl" />
          </div>
          {this.props.subHeader && (
            <DKLabel
              text={this.props.subHeader}
              className="text-gray fs-m mt-s text-align-center"
            />
          )}
          {this.getAllFields()}
          {this.state.addCustomFieldClicked
            ? this.getCustomFieldRow()
            : this.getCustomFieldAction()}
          {this.getFooter()}
          {this.state.needSelectOptionsPopup && this.getSelectOptionsPopup()}
        </div>
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getAllFields() {
    const numberOfColumns = 2;
    const gap = 2;
    const width = 100 / numberOfColumns - gap * 2;
    return (
      <div className="parent-width  mt-l row flex-wrap">
        {(this.state.fieldsData || []).map((item) => {
          return (
            <div
              key={item.key}
              style={{ width: width + "%", margin: gap + "%" }}
              className={
                "p-r p-v-s p-h-s border-box border-radius-s " +
                (item.isSelected
                  ? "bg-chip-blue border-blue "
                  : "bg-chip-gray border-m ") +
                (this.isInputTypeSelect(item)
                  ? " row justify-content-between "
                  : "")
              }
            >
              {this.isInputTypeSelect(item) && (
                <DKIcon
                  style={{ opacity: 0 }}
                  src={DKIcons.ic_edit}
                  className="ic-xs"
                />
              )}
              <div
                className="cursor-hand parent-width"
                onClick={() => this.onFieldSelected(item)}
              >
                <DKLabel
                  className="text-align-center"
                  text={item.isSelected ? "✓ " + item.name : item.name}
                />
              </div>
              {this.isInputTypeSelect(item) && (
                <DKIcon
                  onClick={() => this.showSelectOptionsPopup(item)}
                  src={DKIcons.ic_edit}
                  className="ic-xs cursor-hand"
                />
              )}
            </div>
          );
        })}
      </div>
    );
  }

  isInputTypeSelect(field) {
    return (
      field.type === INPUT_TYPE.SELECT || field.type === INPUT_TYPE.MULTI_SELECT
    );
  }

  getCustomFieldAction() {
    return (
      <div style={{ marginRight: "4%" }} className="row-reverse">
        <DKButton
          title="+ New field"
          onClick={() => this.setAddCustomFieldClicked(true)}
          className="bg-app text-white mt-xl"
        />
      </div>
    );
  }

  getCustomFieldRow() {
    return (
      <div
        style={{ marginLeft: "4%" }}
        className="row parent-width justify-content-between mt-xl"
      >
        <input
          className={
            "border-box p-v-s p-h-s bg-gray1 border-radius-s mr-s " +
            (this.state.customFieldTitleError ? "border-red" : " border-m")
          }
          type="text"
          value={this.state.customFieldTitle || ""}
          onChange={(e) => this.setCustomFieldTitle(e.target.value)}
          placeholder="Title"
        />
        {this.getFieldTypeSection()}
        <div
          className="row cursor-hand"
          style={{ width: "auto" }}
          onClick={() => {
            this.setCustomFieldRequired(!this.state.customFieldRequired);
          }}
        >
          <DKCheckMark
            className="ml-m"
            isSelected={this.state.customFieldRequired}
          />
        </div>
        <DKButton
          style={{ marginRight: "4%" }}
          className="bg-gray1 border-m ml-r"
          icon={DKIcons.ic_save}
          onClick={this.onCustomFieldSave}
        />
      </div>
    );
  }

  getFieldTypeListPicker() {
    return (
      <DKListPicker
        data={this.getFieldTypeData()}
        className="position-absolute border-m shadow-m parent-width"
        style={{ bottom: 36, left: 0 }}
        onSelect={(index) => {
          const fieldType = this.getFieldTypeData(index);
          this.setCustomFieldType(this.getFieldTypeData(index));
          this.setCustomFieldTypeError(false);
          if (
            fieldType === INPUT_TYPE.SELECT ||
            fieldType === INPUT_TYPE.MULTI_SELECT
          ) {
            this.showSelectOptionsPopup();
          }
          this.hideFieldTypeListPicker();
        }}
        onClose={this.hideFieldTypeListPicker}
      />
    );
  }

  getFieldTypeData(index = undefined) {
    let data = [
      INPUT_TYPE.TEXT,
      INPUT_TYPE.NUMBER,
      INPUT_TYPE.DATE,
      INPUT_TYPE.EMAIL,
      INPUT_TYPE.SELECT,
      INPUT_TYPE.MULTI_SELECT,
      'File'
    ];
    if (index !== undefined) {
      return data[index];
    }
    return data;
  }

  getFieldTypeSection() {
    return (
      <div className="column parent-width ">
        <div
          className={
            "row justify-content-between p-h-r p-v-s bg-gray1 border-radius-s position-relative cursor-hand " +
            (this.state.customFieldTypeError ? "border-red " : " border-m")
          }
        >
          <div
            className="parent-width parent-height position-absolute"
            style={{ top: 0, left: 0 }}
            onClick={this.showFieldTypeListPicker}
          />
          <DKLabel
            className=" unselectable"
            text={this.state.customFieldType || "Select Type"}
          />
          <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s unselectable" />
          {this.state.showFieldTypeListPicker && this.getFieldTypeListPicker()}
        </div>
      </div>
    );
  }

  showFieldTypeListPicker = () => {
    if (!this.state.showFieldTypeListPicker) {
      this.setState({ showFieldTypeListPicker: true });
    }
  };

  hideFieldTypeListPicker = () => {
    setTimeout(() => {
      this.setState({ showFieldTypeListPicker: false });
    }, 10);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  onCustomFieldSave = (isFromCustomFieldSave = true) => {
    const customFieldTitle = this.state.customFieldTitle;
    const customFieldType = this.state.customFieldType;
    let validationSuccess = true;
    this.setCustomFieldTitleError(false);
    this.setCustomFieldTypeError(false);

    if (!customFieldTitle || customFieldTitle.trim().length === 0) {
      validationSuccess = false;
      this.setCustomFieldTitleError(true);
    }

    if (!customFieldType) {
      validationSuccess = false;
      this.setCustomFieldTypeError(true);
    }

    if (validationSuccess) {
      if (
        (customFieldType === INPUT_TYPE.SELECT ||
          customFieldType === INPUT_TYPE.MULTI_SELECT) &&
        this.state.selectOptionsData.length === 0
      ) {
        this.onSelectOptionsMissing();
        return;
      }

      let data = {
        name: customFieldTitle,
        type: customFieldType,
        required: this.state.customFieldRequired,
        options:
          customFieldType === INPUT_TYPE.SELECT ||
          customFieldType === INPUT_TYPE.MULTI_SELECT
            ? this.state.selectOptionsData
            : [],
        isSelected: true,
      };

      this.saveCustomFieldData(data, isFromCustomFieldSave);
    }
  };

  saveCustomFieldData(customData, isFromCustomFieldSave) {
    showLoader("Saving... Please wait");
    ContactService.addColumn(
      customData,
      (response) => {
        const { data, columnData } = response;
        if (data.id && columnData) {
          showToast("Field added successfully", TOAST_TYPE.SUCCESS);
          this.updatedFieldsData(
            { ...columnData, key: data.id, isSelected: true },
            isFromCustomFieldSave
          );
        }
        this.updateTableData();
      },
      (error) => {
        removeLoader();
      }
    );
  }

  updateTableData() {
    ContactService.setTableColumns(
      () => {
        removeLoader();
      },
      (error) => {
        removeLoader();
      }
    );
  }

  updatedFieldsData(data, isFromCustomFieldSave) {
    let updatedFieldsData = [...this.state.fieldsData] || [];
    updatedFieldsData.push(data);
    if (!isFromCustomFieldSave) {
      this.saveSelectedFields(updatedFieldsData);
    } else {
      this.setUpdatedFieldsData(updatedFieldsData);
      this.setCustomFieldType(undefined);
      this.setCustomFieldTitle(undefined);
      this.setAddCustomFieldClicked(false);
      this.setShowSaveAction(true);
    }
  }

  onFieldSelected = (selectedField) => {
    if (selectedField && selectedField.required && selectedField.systemField) {
      showAlert("Alert", "Mandatory fields cannot be de-selected.");
      return;
    }
    let updatedFieldsData = this.state.fieldsData.map((item) => {
      let temp = Object.assign({}, item);
      if (temp.key === selectedField.key) {
        temp.isSelected = !selectedField.isSelected;
      }
      return temp;
    });
    this.setUpdatedFieldsData(updatedFieldsData);
    this.setShowSaveAction(true);
  };

  setCustomFieldTitleError = (flag) => {
    this.setState({ customFieldTitleError: flag });
  };

  setCustomFieldTypeError = (flag) => {
    this.setState({ customFieldTypeError: flag });
  };

  setUpdatedFieldsData = (data) => {
    this.setState({
      fieldsData: data,
    });
  };

  setCustomFieldType = (data) => {
    this.setState({
      customFieldType: data,
    });
  };

  setCustomFieldTitle = (data) => {
    if (data && this.state.customFieldTitleError) {
      this.setCustomFieldTitleError(false);
    }
    this.setState({
      customFieldTitle: data,
    });
  };

  setCustomFieldRequired = (flag) => {
    this.setState({
      customFieldRequired: flag,
    });
  };

  setAddCustomFieldClicked = (flag) => {
    this.setState({
      addCustomFieldClicked: flag,
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSelectOptionsPopup() {
    return (
      <FormFieldSelectOptions
        header="Add Options"
        data={this.state.selectedOptionsField}
        onCancel={this.onSelectOptionsPopupCancel}
        onSave={this.onSelectOptionsPopupSave}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSelectOptionsPopup = (data = undefined) => {
    this.setState({
      selectedOptionsField: data,
      needSelectOptionsPopup: true,
    });
  };

  hideSelectOptionsPopup = () => {
    this.setState({
      selectedOptionsField: undefined,
      needSelectOptionsPopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onSelectOptionsPopupSave = (options, fieldData) => {
    if (fieldData) {
      let currentFieldsData = [...this.state.fieldsData].map((item) =>
        item.key === fieldData.key ? fieldData : item
      );
      this.setUpdatedFieldsData(currentFieldsData);
    } else {
      this.setSelectOptionsData(options);
    }
    this.hideSelectOptionsPopup();
  };

  onSelectOptionsPopupCancel = () => {
    this.hideSelectOptionsPopup();
  };

  setSelectOptionsData = (options) => {
    this.setState({
      selectOptionsData: options,
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  cancelTapped = () => {
    this.props.onCancel();
  };

  saveTapped = () => {
    let customFieldTitle = this.state.customFieldTitle;
    let customFieldType = this.state.customFieldType;
    if (customFieldTitle || customFieldType) {
      this.onCustomFieldSave(false);
    } else {
      this.saveSelectedFields();
    }
  };

  saveSelectedFields(allFieldsData = undefined) {
    const arrangedFields = [];
    const selectedFields = [];
    this.state?.selectedArrangedFields.forEach(s => {
        const field = (allFieldsData || this.state.fieldsData).find(
            (item) => s.key === item.key && item.isSelected === true
        );
        if(!Utility.isEmptyObject(field)) {
            field.required = field.required
            arrangedFields.push(field);   
        }
    });
    (allFieldsData || this.state.fieldsData).forEach(f => {
        if(f.isSelected) {
            const fieldIndex = arrangedFields.findIndex(s => s.key === f.key);
            if(fieldIndex === -1) {
                selectedFields.push(f);
                selectedFields.required = f.required;
            }
        }
    });

    const allSelectedFields = arrangedFields.concat(selectedFields);

    if (allSelectedFields.length > 0) {
      this.props.onSave(allSelectedFields);
    } else {
      showAlert("Alert", "Please select atleast 1 field.");
    }
  }

  setShowSaveAction = (show) => {
    this.setState({
      showSaveAction: show,
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  onSelectOptionsMissing = () => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Proceed",
        className: "bg-app text-white ml-r",
        onClick: () => {
          this.showSelectOptionsPopup();
        },
      },
    ];
    showAlert(
      "Alert",
      "Options are missing. Please proceed and add options.",
      buttons
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="row mt-xl justify-content-center">
        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.cancelTapped}
        />
        {(
          <DKButton
            title="Save"
            className="bg-app text-white ml-m"
            onClick={this.saveTapped}
          />
        )}
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export default FormFieldsEditor;
